import React from 'react';
import { Icon } from './Icon.js';
export const IconCube3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 12V17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16.3326 9.49568L12.0025 11.9957L7.67236 9.49567", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 2L21 7L21 17L12 22L3 17V7L12 2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconCube3.js.map